import { Dialog } from "@headlessui/react";
import { ModalFoterBox } from "../../../components/box/Box";
import Button from "../../../components/button/Button";
import { Modal, ModalProp } from "../../../components/modal/Modal";
import { MenuSettingEditItme, MenuSettings } from "../../../model/MenuSettings";
import { SystemMenus } from "../../../model/SystemMenus";
import { VideoMenus } from "../../../model/VideoMenus";
import { RadioSelectCard } from "../../../components/radiobutton/RadioSelectCard";
import { LinkMenus } from "../../../model/LinkMenus";
import { useInput } from "../../../hooks/useInput";
import { useEffect } from "react";
import Badge from "../../../components/badges/Badges";

export type MenuSettingModalProp = {
  editItem?: MenuSettingEditItme | undefined;
  menuSettings: (MenuSettings & {name?: string | undefined})[];
  systemMenusList: SystemMenus[];
  videoMenusList: VideoMenus[];
  linkMenusList: LinkMenus[];
  onSubmitHandler: (data: any) => void;
}

export const MenuSettingModal = ({
  open,
  toggle,
  closeOnClickOutside,
  editItem,
  menuSettings,
  systemMenusList,
  videoMenusList,
  linkMenusList,
  onSubmitHandler,
}: ModalProp & MenuSettingModalProp) => {
  const systemListColor = "yellow";
  const videoMenusListColor = "indigo";
  const linkMenusListColor = "green";

  const menuIdList = menuSettings.map((menu) => menu.menuNo);

  const systemMenusItems = systemMenusList.map((systemMenu) => {
    const isDisabled = menuIdList.includes(systemMenu.id) && editItem?.menuNo !== systemMenu.id;
    return {
      id: systemMenu.id,
      title: (<>{systemMenu.name} <Badge color={!isDisabled ? systemListColor : "disabled"}>{systemMenu.type}</Badge></>),
      disabled: isDisabled,
    }
  });

  const videoMenuItems = videoMenusList.map((videoMenu) => {
    const isDisabled = menuIdList.includes(videoMenu.id) && editItem?.menuNo !== videoMenu.id;
    return {
      id: videoMenu.id,
      title: (<>{videoMenu.name} <Badge color={!isDisabled ? videoMenusListColor : "disabled"}>{videoMenu.type}</Badge></>),
      disabled: isDisabled,
    }
  });

  const linkMenusItems = linkMenusList.map((linkMenu) => {
    const isDisabled = menuIdList.includes(linkMenu.id) && editItem?.menuNo !== linkMenu.id;
    return {
      id: linkMenu.id,
      title: (<>{linkMenu.name} <Badge color={!isDisabled ? linkMenusListColor : "disabled"}>{linkMenu.type}</Badge></>),
      disabled: isDisabled,
    }
  });

  const select = useInput('');

  useEffect(() => {
    select.setValue(editItem?.menuNo ?? '');
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[editItem]);

  return (
    <>
      <Modal
        open={open}
        toggle={toggle}
        closeOnClickOutside={closeOnClickOutside}
      >
        <Dialog.Panel className=" relative transform overflow-hidden rounded-lg bg-white  text-left shadow-xl transition-all sm:w-full max-w-screen-md ">
          <div className="">
            <div className="text-center">
              <Dialog.Title
                as="h3"
                className="px-4 pt-4 text-left text-lg font-medium leading-6 text-gray-900"
              >
                ボタンメニュー項目選択
              </Dialog.Title>
              <div className="overflow-y-auto p-4">
                <div className="text-left h-[500px]">
                  <RadioSelectCard
                    children={undefined}
                    name={"select"}
                    value={select}
                    label={"システムボタンメニュー"}
                    radioSelectCardItem={systemMenusItems}
                    color={systemListColor}
                  />
                  {videoMenuItems.length > 0 ?
                    (<RadioSelectCard
                      children={undefined}
                      name={"select"}
                      value={select}
                      label={"動画メニュー"}
                      radioSelectCardItem={videoMenuItems}
                      color={videoMenusListColor}
                    />) : (<></>)
                  }
                  {linkMenusItems.length > 0 ?
                    (<RadioSelectCard
                        children={undefined}
                        name={"select"}
                        value={select}
                        label={"連携ボタンメニュー"}
                        radioSelectCardItem={linkMenusItems}
                        color={linkMenusListColor}
                      />) : (<></>)
                  }
                  <RadioSelectCard
                    children={undefined}
                    name={"select"}
                    label={"設定削除"}
                    value={select}
                    radioSelectCardItem={[{id: "delete", title: "トップ画⾯から非表示にする"}]}
                    color={"red"}
                    className={"pb-5"}
                  />
                </div>
              </div>
            </div>
          </div>
          <ModalFoterBox>
            <Button
              className="mx-2 mt-1 w-[132px]"
              outline
              onClick={toggle}
              children={'キャンセル'}
            />
            <Button
              className="mt-1 mr-2 w-[132px]"
              onClick={() => {
                onSubmitHandler({menuNo: select.value, menuIndex: editItem?.menuIndex})
              }}
              children={'登録'}
            />
          </ModalFoterBox>
        </Dialog.Panel>
      </Modal>
    </>
  )
}